<template>
  <div>
    <div
      v-for="campaign in getCtwaCampaigns"
      :key="campaign.id"
      class="history-item"
    >
      <div class="content-body" style="margin-top: 2rem">
        <p>
          <strong>{{ formatDate(campaign.created_at) }}</strong>
        </p>

        <p>
          <strong>{{ $t('CTWA_HISTORY.ORIGIN.LABEL') }}</strong>
          {{ campaign.source_type || '-' }}
        </p>

        <p>
          <strong>{{ $t('CTWA_HISTORY.CAMPAIGN.LABEL') }}</strong>
          {{ campaign.source_url || '-' }}
        </p>
      </div>

      <hr
        v-if="
          getCtwaCampaigns.length > 1 &&
          campaign.id !== getCtwaCampaigns[getCtwaCampaigns.length - 1].id
        "
      />
    </div>
  </div>
</template>
  
<script>
import format from 'date-fns/format';
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    conversationId: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      uiFlags: 'historyCtwaCampaigns/getUIFlags',
      getCtwaCampaigns: 'historyCtwaCampaigns/getHistoryCtwaCampaigns',
    }),
  },
  methods: {
    ...mapActions({
      getHistoryCtwaCampaigns: 'historyCtwaCampaigns/get',
    }),
    getAllCtwaHistory() {
      try {
        this.getHistoryCtwaCampaigns({ conversation_id: this.conversationId });
      } catch (error) {
        console.log(error.message);
      }
    },
    formatDate(dateString) {
      if (!dateString) {
        return '-';
      }
      return format(new Date(dateString), 'dd/MM/yyyy - HH:mm');
    },
  },
  watch: {
    conversationId: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.getAllCtwaHistory();
        }
      },
    },
  },
};
</script>
  
<style lang="scss" scoped>
.content-body {
  padding: 0 var(--space-normal);
}

.history-item {
  margin-bottom: 1rem;
}
</style>